import {ReactNode} from "react";
import {css} from "@panda/css";

import {CheckIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

interface IProps {
    children: ReactNode;
}

export const ForYouBannerBenefitItem = (props: IProps) => {
    return (
        <li className={benefitItemStyle}>
            <span className={benefitIconWrapperStyle} aria-hidden="true">
                <CheckIcon size="1.4" wrapperSize="1.6" wrapperColor="var(--colors-success)" />
            </span>
            <Text variant="body_copy_1" as="span" className={benefitTextStyle}>
                {props.children}
            </Text>
        </li>
    );
};

const benefitItemStyle = css({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "start",
    gap: 1
});

const benefitIconWrapperStyle = css({
    width: "1.6rem",
    height: "1.6rem",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    mt: "2px"
});

const benefitTextStyle = css({
    color: "var(--colors-secondary)",
    width: "100%"
});
import {ReactNode} from "react";
import {css} from "@panda/css";

import {CheckIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

interface IProps {
    children: ReactNode;
}

export const ForYouBannerBenefitItem = (props: IProps) => {
    return (
        <li className={benefitItemStyle}>
            <span className={benefitIconWrapperStyle} aria-hidden="true">
                <CheckIcon size="1.4" wrapperSize="1.6" wrapperColor="var(--colors-success)" />
            </span>
            <Text variant="body_copy_1" as="span" className={benefitTextStyle}>
                {props.children}
            </Text>
        </li>
    );
};

const benefitItemStyle = css({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "start",
    gap: 1
});

const benefitIconWrapperStyle = css({
    width: "1.6rem",
    height: "1.6rem",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    mt: "2px"
});

const benefitTextStyle = css({
    color: "var(--colors-secondary)",
    width: "100%"
});
